// extracted by mini-css-extract-plugin
export default {"success":"tags__success","danger":"tags__danger","warning":"tags__warning"};